import CryptoJS from "crypto-js";
import AesUtil from "./AesUtil";
import BaseConstants from "../constants/BaseConstants";

class AppUtils {
  static filterCaseInsensitive(filter, row) {
    try {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? String(row[id].toString().toLowerCase()).startsWith(
            filter.value.toLowerCase()
          )
        : false;
    } catch (e) {
      console.log("filterCaseInsensitive function in AppUtil ", e);
    }
  }

  static reactTablePaginationStyle() {
    return {
      style: {
        backgroundColor: "red",
      },
    };
  }

  static componentToHex(c) {
    let hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  static rgbToHex(r, g, b) {
    return (
      "#" +
      this.componentToHex(r) +
      this.componentToHex(g) +
      this.componentToHex(b)
    );
  }

  static hexToRgb(hex) {
    try {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    } catch (e) {
      console.log("hexToRgb function in AppUtil ", e);
    }
  }

  // static convertArrayToString(arr){
  //    // Iterate over each inner array and convert it to the desired string format
  //    let convertedArr = [];
  //    for (let innerArr of arr) {
  //        let convertedInnerArr = innerArr.map(item => `\\"${item}\\"`);
  //        convertedArr.push(`[${convertedInnerArr.join(",")}]`);
  //    }
  //    // Combine all inner arrays into a single string
  //    let result = `[${convertedArr.join(",")}]`;
  //    return result;
  // }

  static convertArrayToString(arr) {
    // Iterate over each inner array and convert it to the desired string format
    let convertedArr = [];
    for (let innerArr of arr) {
      let convertedInnerArr = innerArr.map((item) => `"${item}"`);
      convertedArr.push(`[${convertedInnerArr.join(",")}]`);
    }
    // Combine all inner arrays into a single string
    let result = `[${convertedArr.join(",")}]`;
    return result;
  }

  static checkNumber(str) {
    let numberRegex = /^-?\d*\.?\d+$/;
    return numberRegex.test(str);
  }

  static generateTestUser(username, password) {
    let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(
      CryptoJS.enc.Hex
    );
    let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
      CryptoJS.enc.Hex
    );
    AesUtil.init(
      BaseConstants.KSTR_KEY_SIZE,
      BaseConstants.KSTR_ITERATION_COUNT
    );
    const encryptedPassword = AesUtil.encrypt(
      salt,
      iv,
      BaseConstants.KSTR_PASSE_PHRASE,
      password
    );
    const user = {
      username: username,
      password: encryptedPassword,
      IV: iv,
      SALT: salt,
    };
    return user;
  }

  static getAuthHeaders(customToken = null){
    const headers = {
      'Content-Type': 'application/json'
    };
    
    // If a custom token is provided (for backward compatibility)
    if (customToken) {
      headers['x-auth-token'] = customToken;
    } 
    // Add Bearer token if available from Keycloak
    // else if (window.keycloak && window.keycloak?.token) {
      headers['Authorization'] = `Bearer ${window.keycloak.token}`;
    // }
    
    return headers;
  }
}

export const PERIODS = ["Month", "Week", "Day", "Hours", "Minutes"];

export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const gridStringFilter=(filter,row)=>{
  const id =  filter.id;
  if(row[id] === undefined){
    console.log("row[id] is undefined", {row});
  }
  return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : false;

}

export default AppUtils;
